<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <edit-bill-form :dialog="dialog" :billDetails="billDetails" @updated="childFormChanged"></edit-bill-form>
  </v-dialog>
</template>

<script>
import EditBillForm from './Widgets/EditBillForm';

export default {
  name: 'BillEditDialog',
  components: {
    EditBillForm
  },
  data: () => ({}),
  props: ['billDetails', 'dialog'],
  computed: {},
  methods: {
    childFormChanged() {
      this.$emit('updated', false);
    }
  }
};
</script>

<style scoped></style>
